import { Component } from '@angular/core';
import { ToasterService, ToasterConfig }  from 'angular2-toaster/angular2-toaster';
import { HeaderService } from '../../components/app-header/app.header.service';

@Component({
  selector: 'app-dashboard',
  template: '<router-outlet></router-outlet><toaster-container [toasterconfig]="toasterconfig"></toaster-container>',
})
export class SimpleLayoutComponent {

  public toasterconfig : ToasterConfig =
    new ToasterConfig({
      tapToDismiss: true,
      timeout: 5000
  });

  constructor(private toasterService: ToasterService) {

    HeaderService.toaster.subscribe(toaster => {
      this.toasterService.pop(toaster.type, toaster.title, toaster.text);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/simple-layout/simple-layout.component.ts